import { render } from "./dialogModifyQuestions.vue?vue&type=template&id=774e3f82"
import script from "./dialogModifyQuestions.vue?vue&type=script&lang=js"
export * from "./dialogModifyQuestions.vue?vue&type=script&lang=js"

import "./dialogModifyQuestions.vue?vue&type=style&index=0&id=774e3f82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__